import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { DisplayNameValidation } from 'src/core/customValidator/displayNameValidator';
import {  Validate} from 'class-validator';

export class ProductServiceTypeDataService extends DataService<typeof Model.Products.Logic.ViewModels.ProductServiceTypeItem, Model.Products.Logic.ViewModels.ProductServiceTypeItem, ProductServiceTypeItem> {
	protected map(entity: Model.Products.Logic.ViewModels.ProductServiceTypeItem): ProductServiceTypeItem {
		return new ProductServiceTypeItemModel(entity);
	}

	public static make(ctx?: any, saveAsDelete: boolean = true): ProductServiceTypeDataService {
		return new ProductServiceTypeDataService(ctx, ctx => ctx.ProductServiceTypes, saveAsDelete);
	}

	public add() {
		const entity = new Model.Products.Logic.ViewModels.ProductServiceTypeItem();

		return entity;
	}
}

export class ProductServiceTypeItemModel extends EntityModel<Model.Products.Logic.ViewModels.ProductServiceTypeItem, ProductServiceTypeItem> implements ProductServiceTypeItem {
	@property<ProductServiceTypeItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<ProductServiceTypeItemModel>(o => o.entity.categoryId, (o, value) => o.entity.categoryId = value)
	public categoryId: number;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	@Validate(DisplayNameValidation, ['en'])
	public dynamicProperties: {};

	@property<ProductServiceTypeItemModel>(o => o.entity.category, (o, value) => o.entity.category = value)
	public category: any;
}



// WEBPACK FOOTER //
// ./src/app/products/product-service-types/list/product-service-type-list.data.ts